import { useEffect, useState, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { QRCodeCanvas } from "qrcode.react";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Download } from "lucide-react";

export default function OutletQR() {
  const { id } = useParams();
  const [outlet, setOutlet] = useState(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    (async () => {
      const { data } = await api.get(`/outlets/${id}`);
      setOutlet(data);
    })();
  }, [id]);

  if (!outlet) return <div className="text-sm text-zinc-500">Memuat...</div>;

  const url = `${window.location.origin}/f/${outlet.slug}`;

  const download = () => {
    const canvas = wrapperRef.current?.querySelector("canvas");
    if (!canvas) return;
    const link = document.createElement("a");
    link.download = `qr-${outlet.slug}.png`;
    link.href = canvas.toDataURL("image/png");
    link.click();
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <Link to="/admin/outlets" className="inline-flex items-center gap-1 text-sm text-zinc-500 hover:text-emerald-700" data-testid="back-outlets-link">
        <ArrowLeft size={14} /> Kembali ke Outlet
      </Link>

      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">QR Code Outlet</h1>
        <p className="text-sm text-zinc-500 mt-1">Cetak dan pajang di outlet Anda.</p>
      </div>

      <div className="bg-white border border-zinc-200 rounded-2xl p-8 flex flex-col items-center">
        <div className="text-center mb-6">
          <div className="text-xs font-semibold uppercase tracking-wider text-zinc-500">Outlet</div>
          <div className="text-xl font-bold mt-1">{outlet.name}</div>
          <div className="text-sm text-zinc-500 mt-1 break-all">{url}</div>
        </div>
        <div ref={wrapperRef} className="p-4 bg-white rounded-2xl border border-zinc-200" data-testid="qr-container">
          <QRCodeCanvas
            value={url}
            size={280}
            level="H"
            includeMargin={false}
            fgColor={outlet.brand_color || "#059669"}
            imageSettings={outlet.logo_url ? { src: outlet.logo_url, height: 48, width: 48, excavate: true } : undefined}
          />
        </div>
        <Button onClick={download} className="mt-6 bg-emerald-600 hover:bg-emerald-700" data-testid="qr-download-button">
          <Download size={16} className="mr-2" /> Unduh QR (PNG)
        </Button>
      </div>
    </div>
  );
}
